import type {RedesignIssue} from '@Components/ai-redesign-prompt-box/ai-redesign-prompt-box.types';
import {RedesignIssueType} from '@Components/ai-redesign-prompt-box/ai-redesign-prompt-box.types';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import {type ReactElement} from 'react';
import styles from './ai-redesign-issue.module.scss';

interface AiRedesignIssueProps {
  redesignIssue: RedesignIssue;
  retry: () => void;
}

export function AiRedesignIssue({redesignIssue, retry}: AiRedesignIssueProps): ReactElement {
  const getRedesignIssue = (): ReactElement => {
    return (
      <div
        className={`flexbox gap-1 spacing-m-t-2 ${styles.redesignIssueBox}  ${redesignIssue.type === RedesignIssueType.ERROR ? styles.redesignIssueError : styles.redesignIssueWarning}`}
      >
        <Icon icon={redesignIssue.icon} size={IconSize.SIZE_ICON_16} className={styles.redesignIssueIcon} />
        <Text val={redesignIssue.message} size={TextSize.XSMALL} />
        <Text val={window.i18next.t('pmwjs_retry')} className={'_cursor-pointer'} bold size={TextSize.XSMALL} underline onClick={retry} />
      </div>
    );
  };

  return getRedesignIssue();
}
